import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-view-specific-box',
  templateUrl: './view-specific-box.component.html',
  styleUrls: ['./view-specific-box.component.css']
})
export class ViewSpecificBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }
}
